import { useEffect } from "react";
import { Link } from "react-router-dom";
import { setPageMeta } from "@/lib/api";

export default function NotFound() {
  useEffect(() => {
    setPageMeta("Page Not Found (404) | Ninja Run Club", "This page does not exist. Find run clubs, training guides, and calculators from the links below.", { noindex: true });
  }, []);
  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center gap-6 px-5 text-center" data-testid="not-found-page">
      <p className="font-display text-6xl lg:text-8xl">404</p>
      <h1 className="font-display text-2xl lg:text-3xl">YOU TOOK A WRONG TURN. IT HAPPENS ON LONG RUNS.</h1>
      <Link to="/" data-testid="not-found-home-link" className="btn-invert bg-white text-ink font-mono-label px-8 py-4 border border-white hover:bg-transparent hover:text-white">
        BACK TO THE START
      </Link>
      <nav aria-label="Popular pages" className="flex flex-wrap justify-center gap-3 mt-2">
        <Link to="/clubs" data-testid="not-found-clubs-link" className="font-mono-label text-white/50 hover:text-white transition-colors">FIND A RUN CLUB</Link>
        <span className="text-white/20">·</span>
        <Link to="/training" className="font-mono-label text-white/50 hover:text-white transition-colors">TRAINING GUIDES</Link>
        <span className="text-white/20">·</span>
        <Link to="/tools" className="font-mono-label text-white/50 hover:text-white transition-colors">CALCULATORS</Link>
        <span className="text-white/20">·</span>
        <Link to="/ranked" className="font-mono-label text-white/50 hover:text-white transition-colors">2026 RANKINGS</Link>
      </nav>
    </div>
  );
}
